import React from 'react'
import { OneSearchForm } from '@fs/zion-homelands-shared'
import { LayoutBand, FlowGrid, usePageWidth, H2, H3, Separator, Cell, Skeleton } from '@fs/zion-ui'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import TopRegionsTable from '../components/TopRegionsTable'

export default function RecordsSection({
  surname,
  count,
  children,
  topRegions,
  regionType = 'provinces',
  onRegionClick,
  loading = false,
  country,
}) {
  const { t } = useTranslation()
  const columns = usePageWidth()({ default: 1, lg: 2 })

  return (
    <LayoutBand marginY="xxl">
      {loading ? (
        <Skeleton.H2 centered lineCount={2} data-testid="loading-skeleton" />
      ) : (
        <div style={{ maxWidth: 625, margin: '0 auto' }}>
          <H2 size="H3" supplementary centered balanced>
            {t(
              'apac.section-templates.records-section.title',
              '{surname} Was Found {count} Times in FamilySearch Records',
              { surname, count }
            )}
          </H2>
        </div>
      )}
      <Separator size="lg" />
      <FlowGrid columnCount={columns} gutters="xl">
        {children}
        <Cell alignY="middle">
          {topRegions && (
            <>
              <TopRegionsTable
                topRegions={topRegions}
                regionType={regionType}
                onRegionClick={onRegionClick}
                loading={loading}
                surname={surname}
                country={country}
              />
              <Separator size="lg" />
            </>
          )}
          <H3 size="H4" supplementary>
            {t('apac.section-templates.records-section.search-an-ancestor', 'Search an Ancestor')}
          </H3>
          <Separator size="sm" />
          <OneSearchForm hideDateField buttonColor="gray" />
        </Cell>
      </FlowGrid>
    </LayoutBand>
  )
}

RecordsSection.propTypes = {
  surname: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  children: PropTypes.node,
  topRegions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      count: PropTypes.number,
      code: PropTypes.string,
      url: PropTypes.string,
    })
  ),
  regionType: PropTypes.string,
  onRegionClick: PropTypes.func,
  loading: PropTypes.bool,
  country: PropTypes.string,
}
